module.exports = __webpack_public_path__ + "img/pic6.ee4f06cf.png";